(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const { html, sectionId, variant } = data || {};
    if (!html || !sectionId || !variant) return;

    const sourcePrice = html.querySelector(`#price-${sectionId}`);
    const priceSelector = sourcePrice?.classList.contains('price--on-sale')
      ? '.price-item--sale'
      : '.price-item--regular';
    const priceText = sourcePrice?.querySelector(priceSelector)?.textContent.trim();

    document.querySelectorAll('[class*="ai-sticky-atc-button-"]').forEach((button) => {
      const section = button.closest('.shopify-section') || document;
      const price = section.querySelector('[class*="ai-sticky-atc-price-"]');

      button.dataset.availableText ||= button.textContent.trim();
      button.dataset.productId = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? button.dataset.availableText
        : window.variantStrings?.soldOut || 'Sold out';

      if (price && priceText) {
        price.setAttribute('aria-live', 'polite');
        price.textContent = priceText;
      }
    });
  });
})();
